export const ANALYTICS_DEBOUNCE = 1000;
export const ANALYTICS_TYPES = {
  TOPNAVIGATION_PROJECTPICKER_PRODUCT_CLICK: 'prodex.top_navigation.product_picker.click',
  TOPNAVIGATION_PROJECTPICKER_PROJECT_CLICK: 'prodex.top_navigation.project_picker.click',
  TOPNAVIGATION_PROJECTPICKER_TEMPLATE_CLICK: 'prodex.top_navigation.project_picker.template.click',
  TOPNAVIGATION_PROJECTPICKER_SEARCH_CHANGED: 'prodex.top_navigation.project_picker.search.changed',
  TOPNAVIGATION_PROJECTPICKER_ALLPROJECTS_CLICK: 'prodex.top_navigation.project_picker.all_projects.click',
  TOPNAVIGATION_PROJECTPICKER_VIEWALL_CLICK: 'prodex.top_navigation.project_picker.view_all.click',
  TOPNAVIGATION_HELP_CLICK: 'prodex.top_navigation.help.help.click',
  TOPNAVIGATION_HELP_LEARNINGCENTER_CLICK: 'prodex.top_navigation.help.learning_center.click',
  TOPNAVIGATION_HELP_CONTACTSUPPORT_CLICK: 'prodex.top_navigation.help.contact_support.click',
  TOPNAVIGATION_HELP_TERMSCONDITIONS_CLICK: 'prodex.top_navigation.help.terms_conditions.click',
  TOPNAVIGATION_HELP_LICENSEATTRIBUTIONS_CLICK: 'prodex.top_navigation.help.license_attributions.click',
  TOPNAVIGATION_USERAREA_CLICK: 'prodex.top_navigation.user_area.click',
  TOPNAVIGATION_USERAREA_MYSUBSCRIPTIONS_CLICK: 'prodex.top_navigation.user_area.my_subscriptions.click',
  TOPNAVIGATION_USERAREA_NOTIFICATIONSETTINGS_CLICK: 'prodex.top_navigation.user_area.notification_settings.click',
  TOPNAVIGATION_USERAREA_PROFILESETTINGS_CLICK: 'prodex.top_navigation.user_area.profile_settings.click',
  TOPNAVIGATION_USERAREA_SIGNOUT_CLICK: 'prodex.top_navigation.user_area.sign_out.click'
};
//# sourceMappingURL=analytics.js.map